import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { connect, useSelector } from 'react-redux';
import Faqs from './faqs/faqs';
import Footer from '../../rows/new-footer/new-footer';
import Pricing from './pricing/pricing';
import ResearchReports from './research-reports/research.reports';
import './subscribe/subscribe.m.css';

import ProfitSubscription from './profit-subscription';
import SubscriptionBanner from './subscription-banner';
import SubscriptionNavbar from './subscription-navbar';
import PremiumStories from './premium-stories';
import MobileBottomSticky from '../../molecules/mobile-bottom-sticky';

const Subscription = ({ faq, terms, ...props }) => {
  const [premium, setPremium] = useState(null);
  const isSubscriber = useSelector((state) => get(state, ['userData', 'isSubscriber'], null));
  const [isMenu, setMenu] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    window.addEventListener('message', function (evt) {
      if (evt.data && evt.data === 'openSupport') {
        const contactForm = document.getElementById('contact-btn');
        contactForm.click();
      }
    });
  }, [terms]);

  useEffect(() => {
    const sotries = async () => {
      await fetch('/api/v1/collections/premium?item-type=story')
        .then((res) => res.json())
        .then((res) => {
          setPremium(res);
        });
    };
    sotries();
  }, []);
  const restoreScrollAfterLazyLoad = () => {
    let lastScrollY = window.scrollY;

    const observer = new MutationObserver(() => {
      window.scrollTo(0, lastScrollY);
    });

    observer.observe(document.body, { childList: true, subtree: true });

    window.addEventListener('scroll', () => {
      lastScrollY = window.scrollY;
    });

    return () => {
      observer.disconnect();
      window.removeEventListener('scroll', () => {
        lastScrollY = window.scrollY;
      });
    };
  };
  useEffect(restoreScrollAfterLazyLoad, []);
  const hideShowMobileMenu = (value) => {
    setMenu(value);
  };
  const [isAmpPage, setAmpPage] = useState(false);
  useEffect(() => {
    setAmpPage(location.search?.includes('reader_id=amp'));
  }, []);

  return (
    <div styleName="subscription-wrap">
      <MobileBottomSticky isAmpPage={isAmpPage} />
      <div styleName={`overlay-div ${isMenu ? 'show' : ''}`} onClick={() => setMenu(false)}></div>
      <div className="container desktop-only" styleName="nav-section">
        <SubscriptionNavbar />
      </div>
      <div className="mobile-only" styleName={`nav-section ${isScrolled ? 'scrolled' : ''}`}>
        <SubscriptionNavbar isMenu={isMenu} hideShowMobileMenu={hideShowMobileMenu} />
      </div>
      <ProfitSubscription plans={props?.data?.subscriptionPlans} />
      <PremiumStories sotries={premium} isSubscriber={isSubscriber} />
      <ResearchReports isSubscriber={isSubscriber} />
      <Pricing />
      <Faqs faqs={faq} />
      {isSubscriber === false && isSubscriber !== null && <SubscriptionBanner />}
      <div styleName="footer" id="footer">
        <Footer isSubscription={true} />
      </div>
    </div>
  );
};

Subscription.propTypes = {
  faq: PropTypes.object.isRequired,
  terms: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  const subscriptionConfig = state.qt.config.subscriptions;
  const publisherConfig = state.qt.config.publisher;
  return {
    faq: subscriptionConfig.faq,
    typeFormConfig: get(publisherConfig, ['typeform'], ''),
    terms: get(state, ['qt', 'config', 'subscriptions', 'terms'], {}),
  };
};

export default connect(mapStateToProps, null)(Subscription);
